"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const clsx_1 = __importDefault(require("clsx"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const SubmissionFilters_1 = __importDefault(require("./SubmissionFilters"));
const param_1 = require("@App/navigation/param");
const match_history_store_1 = require("@App/stores/rightsholder/match-history-store");
const SubmissionFilterSection = (0, mobx_react_1.observer)((props) => {
    const { matchHistoryStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { setLoading } = props;
    const methods = (0, react_hook_form_1.useForm)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const [isSidebarOpen, setIsSidebarOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const matchFilterQueryParam = searchParams.get(param_1.SEARCH_PARAM.matchHistoryFilter);
        if (matchFilterQueryParam) {
            const mergedDefaults = Object.assign(Object.assign({}, match_history_store_1.checkboxDefaults), { [matchFilterQueryParam.toString()]: true });
            setSearchParams({});
            setFilters(Object.assign({}, mergedDefaults));
        }
        // Set values form based on the current filter in the store
        Object.keys(matchHistoryStore.matchSuggestionHistoryFilter).forEach((value) => {
            const status = value;
            if (matchHistoryStore.matchSuggestionHistoryFilter[status]) {
                methods.setValue(`filter.${value}`, matchHistoryStore.matchSuggestionHistoryFilter[status]);
            }
        });
    }, []);
    const setFilters = (filter) => {
        if (filter) {
            matchHistoryStore.setMatchSuggestionHistoryFilter(filter);
        }
    };
    const search = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSidebarOpen(false);
        setLoading(true);
        matchHistoryStore.setMatchSuggestionHistoryPaginationBody({
            page: 1,
            limit: matchHistoryStore.matchSuggestionHistoryResultsLimit,
        });
        yield matchHistoryStore.loadMatchSuggestionHistory();
        setLoading(false);
    });
    return (react_1.default.createElement("div", { className: 'match-submission-filter' },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('sidebar-wrapper', isSidebarOpen ? 'open' : 'closed') },
                react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => setIsSidebarOpen(false) },
                    react_1.default.createElement(SubmissionFilters_1.default, { handleFilterValueChange: setFilters, onApplyFilter: search, onResetFilter: search }))),
            !isSidebarOpen && (react_1.default.createElement(Button_1.Button, { type: 'secondary', className: 'sidebar-button', onClick: () => setIsSidebarOpen(true), mainColor: true },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: 'button-text' },
                        "Filters (",
                        matchHistoryStore.matchSuggestionHistoryFilterCount,
                        ")"),
                    react_1.default.createElement("img", { alt: 'filter', src: common_1.ICONS.filter })))))));
});
exports.default = SubmissionFilterSection;
